import { UploadValidationStatus } from '../../../../consts/uploadValidationStatus';
import { getUploadValidationStatusColors } from '../helpers/uploadValidation';
import { stylesheet } from 'typestyle';
import React from 'react';

const css = stylesheet({
  container: {
    marginTop: 8,
  },
});

interface Props {
  globalValidationStatus: UploadValidationStatus | null;
}

export const GlobalUploadValidation = ({ globalValidationStatus }: Props) => {
  // We will ignore Warning level errors for now
  if (globalValidationStatus !== UploadValidationStatus.HasErrors) {
    return null;
  }

  const color = getUploadValidationStatusColors(globalValidationStatus);

  return (
    <div className={css.container} style={{ color: color.primary }}>
      Validation issues found. Please review the uploads.
    </div>
  );
};
